import { type PropsWithChildren } from 'react';
import { tokens } from '@hotjar/hotsauce';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import type { Logger } from '../types';

interface ErrorFallbackInterface {
  (props: { error: Error }): JSX.Element;
}

const ErrorFallback: ErrorFallbackInterface = () => {
  return (
    <div role="alert" data-testid="mfe-error" style={{ padding: tokens.spacer.x2 }}>
      <p>Something went wrong</p>
    </div>
  );
};

interface ErrorBoundaryInterface {
  (props: PropsWithChildren<{ logger: Logger }>): JSX.Element;
}

export const ErrorBoundary: ErrorBoundaryInterface = ({ children, logger }) => (
  <ReactErrorBoundary
    onError={(error) => {
      logger.error(error.message);
      logger.addError(error);
    }}
    FallbackComponent={ErrorFallback}
  >
    {children}
  </ReactErrorBoundary>
);
